import { render, staticRenderFns } from "./audition-index.vue?vue&type=template&id=f4460628&scoped=true"
import script from "./audition-index.vue?vue&type=script&lang=js"
export * from "./audition-index.vue?vue&type=script&lang=js"
import style0 from "./audition-index.vue?vue&type=style&index=0&id=f4460628&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4460628",
  null
  
)

export default component.exports